import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { FETCH_FLP_ACCESS, FETCH_FLP_ACCESS_BULK } from 'automation-ui-permissions/flp/queries/flpAccessQueries';
import { FlpPermissions } from 'automation-ui-permissions/flp/models/EnumedFlowPermissions';
import { ENFORCE_FIELD_LEVEL_PERMISSIONS } from 'automation-ui-permissions/flp/constants/Gates';
export const useFlpAccess = flowId => {
  const isUngatedForFlpAccess = useIsUngated(ENFORCE_FIELD_LEVEL_PERMISSIONS);
  const {
    loading,
    data,
    error
  } = useQuery(FETCH_FLP_ACCESS, {
    variables: {
      flowId: flowId
    },
    skip: !isUngatedForFlpAccess || !flowId
  });
  if (!isUngatedForFlpAccess) {
    return {
      loading: false,
      data: new FlpPermissions({
        flowId: flowId,
        hasViewPermission: true,
        hasEditPermission: true,
        hasDeletePermission: true,
        fieldLevelPermissionReasons: []
      })
    };
  }

  // This shouldn't happen, but we use non-null assertions in many places upstream
  if (flowId === undefined || flowId === null) {
    console.warn('useFlpAccess called without a flowId');
    return {
      loading: false,
      data: new FlpPermissions({
        flowId: 0,
        hasViewPermission: false,
        hasEditPermission: false,
        hasDeletePermission: false,
        fieldLevelPermissionReasons: []
      })
    };
  }
  return {
    loading,
    data: data === null || data === void 0 ? void 0 : data.fetchFlpAccess,
    error
  };
};
export const useFlpAccessBulk = flowIds => {
  const isUngatedForFlpAccess = useIsUngated(ENFORCE_FIELD_LEVEL_PERMISSIONS);
  const {
    loading,
    data,
    error
  } = useQuery(FETCH_FLP_ACCESS_BULK, {
    variables: {
      flowIds
    },
    skip: !isUngatedForFlpAccess
  });
  const flowIdsToEnumedPermissions = useMemo(() => {
    var _data$fetchFlpAccessB;
    return data === null || data === void 0 || (_data$fetchFlpAccessB = data.fetchFlpAccessBulk) === null || _data$fetchFlpAccessB === void 0 ? void 0 : _data$fetchFlpAccessB.results.reduce((acc, permissions) => {
      acc[permissions.flowId] = permissions;
      return acc;
    }, {});
  }, [data]);
  if (!isUngatedForFlpAccess) {
    return {
      loading: false,
      data: flowIds.reduce((acc, flowId) => {
        acc[flowId] = new FlpPermissions({
          flowId,
          hasViewPermission: true,
          hasEditPermission: true,
          hasDeletePermission: true,
          fieldLevelPermissionReasons: []
        });
        return acc;
      }, {})
    };
  }
  return {
    loading,
    data: flowIdsToEnumedPermissions,
    error
  };
};